$(function() {
	var ua = navigator.userAgent;

	var parts = ua.match(/[UNI]; Android (\d+)\.(\d+)/i);
	if (parts) {
		$(document.body).addClass("shitty-android android-"+parts[1]+"-"+parts[2]+" android-"+parts[1]);
	}


});